import React, { Component } from 'react'
import Card from './Card'
import injectSheet from 'react-jss'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { formStyle } from '../../Theme/Theme'
import * as Actions from '../../Actions/Actions'
import { apiUrl } from '../../Utility'
// import ReactGA from 'react-ga'
import {HotKeys} from 'react-hotkeys';

class Signin extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      error: null
    }
  }

  render() {
    const { classes } = this.props
    const { Header, Body, Footer, NextButton, WrongMenuText, ErrorText } = classes

    const map = {
      signin: 'enter'
    };

    const handlers = {
      signin: this.onSubmit
    }
    return (  
      <Card>
        <HotKeys keyMap={map} handlers={handlers}>
          <div className={Header}>
            <h1>Sign In</h1>
            {this.state.error ? <span className={ErrorText}><i className="fas fa-exclamation-triangle"/> {this.state.error}</span> : null}
          </div>
          <div className={Body}>
            <input name="email" type="email" placeholder='Email' value={this.state.email} onChange={this.onChange}/>
            <input name="password" type="password" placeholder='Password' value={this.state.password} onChange={this.onChange}/>
          </div>
          <div className={Footer}>
            <span className={WrongMenuText}><Link to='/welcome/loginHelp'>Forgot your password?</Link></span>
            <a ref={'submit'} className={NextButton} onClick={this.onSubmit}>Sign In</a>
            <span className={WrongMenuText}>New to Spectiv? <Link to='/welcome/signup'>Sign Up</Link></span>
          </div>
        </HotKeys>
      </Card>    
    )
  }

  componentDidMount () {
    // ReactGA.pageview('/signin');
  }     

  onChange = e => {
    const name = e.target.name
    const value = e.target.value
    this.setState({ [name]: value })
  }

  onSubmit = () => {
    const { email, password } = this.state
    fetch(`https://${apiUrl}/api/v1/login?email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`, { method: 'POST'})
    .then(response => {
      response.json().then(data => {
        if (data.status !== 'success') {
          this.onFailure(data.message)
          console.log(data)
        } else {
          this.props.dispatch(Actions.signIn(data.token, this.props.history))
        }
      })
    })
  }

  onFailure = message => {
    this.setState({ error: message })
  }
}

export default withRouter(connect()(injectSheet(formStyle)(Signin)))


// WEBPACK FOOTER //
// ./src/js/Components/LandingPage/Signin.jsx